import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormForeignState, { ForeignStateForm } from 'system/geographic/components/state/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonForeignStateCrumbs } from '../constants';
import { toast } from 'react-toastify';

const ForeignStateNewPage = (): React.ReactElement => {
  const { post: insertForeignState } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/stato`);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: ForeignStateForm | undefined) => {
      insertForeignState({
        codIstat: formValues?.code,
        nome: formValues?.name,
        esonimo: formValues?.exonym,
        endonimo: formValues?.endonym,
        codiceCittadinanza: formValues?.citizenship,
        nomeCittadino: formValues?.citizenMale,
        nomeCittadina: formValues?.citizenFemale,
        belfiore: formValues?.fiscalCode,
        iso: formValues?.isoCode,
        codiceCapitale: formValues?.capitalCode,
        flagRilascioCI: formValues?.releaseUE ? '1' : '0',
        flagUnioneEuropea: formValues?.ue,
        siglaMotorizzazione: formValues?.license,
        cmnAssegn: 0,
        key: {
          codice: formValues?.acronym,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/estero/stato');
      });
    },
    [insertForeignState, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonForeignStateCrumbs, { name: 'Nuovo Stato Estero' }]} />
      <FormForeignState
        title="Nuovo Stato Estero"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/geografiche/estero/stato');
        }}
      />
    </Fragment>
  );
};

ForeignStateNewPage.displayName = 'Foreign State new page component';

export default ForeignStateNewPage;
